import React from "react";
import "./TagpayDetailsComponent.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import Button from "@mui/material/Button";
import refundpay from "../../../../assests/refundpay.svg";
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import recevied from "../../../../assests/recevied.svg";
import recharge from "../../../../assests/recharge.svg";
import rechargeIcon from "../../../../assests/rechargeIcon.svg";
import cross from "../../../../assests/cross.svg";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";

const TagpayDetailsComponent = (props) => {
  const {
    loading,
    fetchRechargeDetails,
    searchValue,
    handleSearchInputChange,
    updateCardStatusApi,
    handleSubmit,
    setAmount,
    handleToggleAll,
    isAllActive,
    isRechargePopupOpen,
    handleOpenRechargePopup,
    handleRechargeAmountChange,
    handleRechargeSubmit,
    deactivateAllCards,
    handleCloseRechargePopup,
    rechargeAmount,
    uid,
    handleToggleCardStatus,
    selectedView,
    setSelectedView,
    handleActivateAll,
    deactivateAllCardStatus,
  } = props;
  
  const navigate = useNavigate();
  
  const goback = () => navigate(-1);

  const renderActivateDeactivateButtons = () => {
    if (selectedView === "active") {
      return (
        <Button
          variant="contained"
          className="action-button"
          onClick={deactivateAllCards}
        >
          Deactivate All
        </Button>
      );
    } else if (selectedView === "inactive") {
      return (
        <Button
          variant="contained"
          className="action-button"
          onClick={handleActivateAll}
        >
          Activate All
        </Button>
      );
    } else if (selectedView === "all") {
      return (
        <Button
          variant="contained"
          className="action-button"
          onClick={handleActivateAll}
          disabled
        >
          Deactivate All
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="tagpay-details-container">
      <Sidebar />
      
      <div className="tagpay-details-content">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="tagpay-details-header">
              <button onClick={goback} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h2>All Tags</h2>
            </div>

            <div className="tagpay-controls">
              <div className="tagpay-searchbar-container">
                <input
                  type="search"
                  placeholder="Search by Tag ID"
                  value={searchValue}
                  onChange={handleSearchInputChange}
                />
                <button className="search-button">
                  <img src={search} alt="Search" />
                </button>
              </div>

              <select
                className="view-select"
                value={selectedView}
                onChange={(e) => setSelectedView(e.target.value)}
              >
                <option value="all">View All Tags</option>
                <option value="active">View Active Tags</option>
                <option value="inactive">View Inactive Tags</option>
              </select>

              {renderActivateDeactivateButtons()}
            </div>

            <div className="tagpay-cards-container">
              {fetchRechargeDetails.length > 0 ? (
                <div className="tagpay-cards-grid">
                  {fetchRechargeDetails.map((tagDetail) => (
                    <Card 
                      key={tagDetail.uid} 
                      className={`tagpay-card ${tagDetail.status === "active" ? "card-active" : "card-inactive"}`}
                    >
                      <CardContent>
                        <div className="card-header">
                          <img 
                            src={tagDetail.status === "active" ? recevied : refundpay} 
                            alt="Status" 
                            className="card-icon"
                          />
                          <div className="card-amount">₹ {tagDetail.balance}</div>
                        </div>

                        <div className="card-details">
                          <div className="card-detail-item">
                            <span className="card-detail-label">Tag ID:</span>
                            <span className="card-detail-value">{tagDetail.uid}</span>
                          </div>
                          <div className="card-detail-item">
                            <span className="card-detail-label">Status:</span>
                            <span className="card-detail-value" style={{
                              color: tagDetail.status === "active" ? "var(--primary-color)" : "var(--secondary-color)"
                            }}>
                              {tagDetail.status}
                            </span>
                          </div>
                        </div>

                        <div className="card-toggle">
                          <span className="card-toggle-label">
                            {tagDetail.status === "active" ? "Active" : "Inactive"}
                          </span>
                          <Switch
                            checked={tagDetail.status === "active"}
                            onChange={() => handleToggleCardStatus(tagDetail.uid, tagDetail.status)}
                            color="success"
                          />
                        </div>

                        <CardActions className="card-footer">
                          <Button
                            variant="contained"
                            className={`recharge-button ${tagDetail.status === "active" ? "active" : "inactive"}`}
                            onClick={() => tagDetail.status === "active" && 
                              handleOpenRechargePopup(tagDetail.uid, tagDetail.amount, tagDetail.reason)}
                            disabled={tagDetail.status !== "active"}
                          >
                            <img src={recharge} alt="Recharge" style={{ marginRight: "8px" }} />
                            Recharge
                          </Button>
                        </CardActions>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              ) : (
                <div className="no-tags-message">
                  <div>
                    <p>No tags available</p>
                    <p>Please add tags or check your filters</p>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {isRechargePopupOpen && (
          <div className="recharge-overlay">
            <div className="recharge-popup">
              <div className="popup-header">
                <div className="popup-title">
                  <img src={rechargeIcon} alt="Recharge" />
                  <span>Recharge</span>
                </div>
                <img 
                  src={cross} 
                  alt="Close" 
                  className="popup-close"
                  onClick={handleCloseRechargePopup}
                />
              </div>

              <div className="popup-body">
                <p style={{ textAlign: "left", marginBottom: "1rem" }}>
                  Tag ID: {uid}
                </p>
                <input
                  type="text"
                  className="popup-input"
                  placeholder="Enter recharge amount"
                  value={rechargeAmount}
                  onChange={handleRechargeAmountChange}
                />
                <Button 
                  variant="contained" 
                  className="popup-button"
                  onClick={handleRechargeSubmit}
                >
                  Recharge
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TagpayDetailsComponent;